export default "__VITE_ASSET__CDaDi3mf__"